class LWBack extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    render() {
        const linkAttr = this.getAttribute('link');
        const href = linkAttr || '#';
        const isRight = this.getAttribute('dir') === 'right';
        const label = this.escape(this.getAttribute('label') || (isRight ? 'Verder' : 'Terug'));

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                position: absolute;
                top: 20px;
                /* Positionering op basis van richting */
                ${isRight ? 'right: 20px;' : 'left: 20px;'}
                width: 10%;
                z-index: 20;
                pointer-events: auto;
                cursor: pointer;
            }

            .back-wrapper {
                width: 100%;
                display: flex;
                align-items: flex-start;
                transition: transform 0.3s ease;
                text-decoration: none;
                /* Draai het hele plaatje/slot om als het 'right' is */
                ${isRight ? 'transform: rotate(180deg);' : ''}
            }

            .back-wrapper:hover {
                /* Hover effect meebewegen met de richting */
                transform: ${isRight ? 'rotate(180deg) translateX(-5px)' : 'translateX(-5px)'};
            }

            .back-wrapper:focus-visible {
                outline: 3px solid #111;
                outline-offset: 4px;
                box-shadow: 0 0 0 6px #fff;
            }

            @media (prefers-reduced-motion: reduce) {
                .back-wrapper {
                    transition: none;
                }
            }

            ::slotted(img), ::slotted(svg) {
                width: 100%;
                height: auto;
                display: block;
                filter: drop-shadow(0 2px 10px rgba(0,0,0,0.5));
            }

            @media (max-width: 767px) {
                :host {
                    top: 20px;
                    width: 12%;
                    ${isRight ? 'right: 20px; left: auto;' : 'left: 20px; right: auto;'}
                }
            }

            @media (min-width: 768px) {
                :host {
                    top: 60px;
                    width: 100px;
                    ${isRight ? 'right: 60px; left: auto;' : 'left: 60px; right: auto;'}
                }
            }
        </style>
        <a href="${this.escape(href)}" class="back-wrapper" aria-label="${label}">
            <slot></slot>
        </a>
        `;

        if (!linkAttr) {
            this.shadowRoot.querySelector('a').addEventListener('click', (event) => {
                event.preventDefault();
                history.back();
            });
        }
    }

    escape(value) {
        return String(value)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;');
    }
}

customElements.define('lw-back', LWBack);